import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { assign, orderBy } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '@app/shared/services/auth.service';
import { BuildingTypesService } from '@app/shared/services/api/building-types.services';
import { BuildingTypes } from '@app/shared/models/building-types';

@Component({
  selector: 'app-description-object-type',
  templateUrl: './description-object-type.component.html',
  styleUrls: ['./description-object-type.component.scss'],
})
export class DescriptionObjectTypeComponent implements OnInit, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  @Input() data: any;
  @Input() editType: number = 0;
  @Output() saveEmitter: EventEmitter<any> = new EventEmitter<any>();
  public buildingTypes: BuildingTypes[] = [];

  constructor(public authService: AuthService, private buildingTypeService: BuildingTypesService) {}

  public ngOnInit(): void {
    this.buildingTypeService
      .getAll()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((types: BuildingTypes[]) => {
        this.buildingTypes = orderBy(types, ['name'], ['asc']);
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public save(): void {
    this.saveEmitter.emit(this.data);
  }

  public setType(buildingType: BuildingTypes): void {
    const building = this.data;
    building.name = buildingType.name;
    building.buildingTypeId = buildingType.guid;
    building.icon = `/assets/icons/` + buildingType.imageName;

    this.data = assign(building, {
      buildingType: {
        name: buildingType.name,
        buildingTypeId: buildingType.guid,
        imageName: buildingType.imageName,
      },
    });
  }

  public showObjectLocation(): void {
    alert('building');
  }
}
